import { GuideNavigationStep } from './GuideNavigationStep'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button, Collapse, Stack } from '@mui/material'
import { GuideNavigationChapterData } from '../data/GuideNavigationChapterData'

export interface GuideNavigationBlockChapterProps {
  data: GuideNavigationChapterData
  isExpanded: boolean
  toggleIsExpanded: () => void
}

export const GuideNavigationChapter = ({
  data,
  isExpanded,
  toggleIsExpanded,
}: GuideNavigationBlockChapterProps) => {
  return (
    <>
      <Button
        variant="text"
        size="small"
        endIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
        onClick={toggleIsExpanded}
        sx={{
          color: 'unset',
          fontWeight: 'bold',
          backgroundColor: 'none',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        {data.title}
      </Button>
      <Collapse in={isExpanded}>
        <Stack direction="column" gap={1}>
          {data.steps.map((step) => (
            <GuideNavigationStep key={step.title} data={step} />
          ))}
        </Stack>
      </Collapse>
    </>
  )
}
